

/* tslint:disable */



export enum RuleType {
    CodeableConcept = 1,
    String = 2,
    Boolean = 3,
    Number = 4,
    DateTime = 5,
    StringArray = 6,
    NumberArray = 7,
    CodeableConceptValueArray = 8,
    Ratio = 9,
    NumberRange = 10,
    DateTimeRange = 11,
    TimeSpan = 12,

}


